import { Field, FieldProps, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const BulkDeletePhoneLinesForm = ({ initialValues, onSubmit }: BulkDeletePhoneLinesFormProps) => {
  const { t } = useTranslation();


  const validationSchema= Yup.object({
    callNumberFrom: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    callNumberTo: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    countOfCallNumbersToDelete: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    deletionDate: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    deletionComments: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ errors, touched, isSubmitting, values, getFieldProps }) => (
        <Form>
          <Container fluid className="p-0">
            <Row>
              <Col xs={6}>
                <label className="form-label">
                  {t("Αριθμός Κλήσης Από")}
                </label>
                <Field
                  name="callNumberFrom"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="callNumberFrom"
                  
                />
                <div className="text-danger">
                  {errors.callNumberFrom && touched.callNumberFrom && (
                    <div>{errors.callNumberFrom}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Έως")}
                </label>
                <Field
                  name="callNumberTo"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="callNumberTo"
                  
                />
                <div className="text-danger">
                  {errors.callNumberTo && touched.callNumberTo && (
                    <div>{errors.callNumberTo}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Ποσότητα αριθμών (εν σειρά) για απενεργοποίηση")}
                </label>
                <Field
                  name="countOfCallNumbersToDelete"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="countOfCallNumbersToDelete"
                  
                />
                <div className="text-danger">
                  {errors.countOfCallNumbersToDelete && touched.countOfCallNumbersToDelete && (
                    <div>{errors.countOfCallNumbersToDelete}</div>
                  )}
                </div>
              </Col>

              <Col xs={6}>
                <label className="form-label">
                {t("Ημερομηνία Διαγραφής")}
                </label>
                <Field 
                  name="deletionDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>
                <div className="text-danger">
                  {errors.deletionDate && touched.deletionDate && (
                    <div> {errors.deletionDate.toString()}</div>
                  )}
                </div>               
              </Col>

              <Col xs={6}>
                <label className="form-label">
                  {t("Σχόλια Διαγραφής")}
                </label>
                <Field
                  type="text"
                  name="deletionComments"
                  field="deletionComments"
                  className="form-control"
                  as="textarea"
                />
                <div className="text-danger">
                  {errors.deletionComments && touched.deletionComments && (
                    <div>{errors.deletionComments}</div>
                  )}
                </div>
              </Col>
          
            </Row>
          </Container>

          <div className="mb-3">
            <Button
              type="submit"
              size="sm"
              styletype="primary"
              disabled={isSubmitting}
            >
              Διαγραφή
            </Button>
          </div>
        </Form>
    )}
    </Formik>
)
}

export default BulkDeletePhoneLinesForm;

type CreateOrEdit =
 {
    initialValues: IBulkDeletePhoneLines;
    onSubmit: (
      values: IBulkDeletePhoneLines,
      formikHelpers: FormikHelpers<IBulkDeletePhoneLines>
    ) => void;
  }


type BulkDeletePhoneLinesFormProps = CreateOrEdit;